import { useState } from 'react';
import axios from 'axios';

const useRegearLogic = () => {
  const [deathId, setDeathId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState('hidden');
  const [responseMessage, setResponseMessage] = useState('');

  async function submitDeathId(id) {
    if (deathId === '') {
      return;
    }

    setIsLoading(true);
    setResponse('hidden');
    try {
      await axios
        .get(process.env.REACT_APP_API_SERVER + '/regearSubmit', {
          params: {
            deathId: id,
          },
        })
        .then(function (response) {
          setDeathId('');
          setResponse(response.data[0]);
          setResponseMessage(response.data[1]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {
      if (!err.response) {
        setResponse('Denied');
        setResponseMessage('Server is down for maintenance. Contact Onslawht');
        return
      }
      setResponse(err.response.data[0]);
      setResponseMessage(err.response.data[1]);
    }
  }

  return {
    //functions
    submitDeathId,
    //setState
    setDeathId,
    setIsLoading,
    setResponse,
    //state
    deathId,
    isLoading,
    response,
    responseMessage,
  };
};

export default useRegearLogic;
